import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { mapDate } from '../actions/map';
import MapIcon from '@mui/icons-material/Map';
import CloseIcon from '@mui/icons-material/Close';
var FilteredItem = function FilteredItem(props) {
  var _selectedFilters$loca, _selectedFilters$date, _selectedFilters$type;
  var navigate = useNavigate();
  var params = useParams();
  var dispatch = useDispatch();
  var selectedFilters = props.selectedFilters,
    eventTypes = props.eventTypes,
    onSelectFilter = props.onSelectFilter;
  var commonstlye = {
    fontSize: 12,
    paddingTop: 3,
    paddingBottom: 3,
    paddingLeft: 6,
    paddingRight: 6,
    color: '#FFF',
    display: 'inline-flex',
    gap: 3,
    alignItems: 'center',
    backgroundColor: '#000',
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "filtered-items-wrapper",
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 4,
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "filtered-item",
    style: _objectSpread(_objectSpread({}, commonstlye), {}, {
      paddingLeft: 8,
      paddingRight: 8
    })
  }, /*#__PURE__*/React.createElement("span", null, (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.option) === 'in-person' ? 'In Person' : 'Virtual')), (selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$loca = selectedFilters.location) === null || _selectedFilters$loca === void 0 ? void 0 : _selectedFilters$loca.length) > 0 && selectedFilters.location.map(function (it) {
    return /*#__PURE__*/React.createElement("div", {
      className: "filtered-item",
      style: commonstlye,
      key: it === null || it === void 0 ? void 0 : it.place_id
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      sx: {
        fontSize: 12,
        borderRadius: '50%',
        backgroundColor: '#DDD',
        color: '#000'
      },
      onClick: function onClick() {
        var _selectedFilters$loca2;
        var locations = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.location;
        locations === null || locations === void 0 || locations.splice(selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$loca2 = selectedFilters.location) === null || _selectedFilters$loca2 === void 0 ? void 0 : _selectedFilters$loca2.indexOf(it), 1);
        onSelectFilter('location', locations);
      }
    }), /*#__PURE__*/React.createElement("span", null, it === null || it === void 0 ? void 0 : it.label));
  }), (selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$date = selectedFilters.date) === null || _selectedFilters$date === void 0 ? void 0 : _selectedFilters$date.length) > 0 && selectedFilters.date.map(function (it) {
    var _Date;
    return /*#__PURE__*/React.createElement("div", {
      className: "filtered-item",
      style: commonstlye,
      key: it
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      sx: {
        fontSize: 12,
        borderRadius: '50%',
        backgroundColor: '#DDD',
        color: '#000'
      },
      onClick: function onClick() {
        var _selectedFilters$date2;
        var dates = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.date;
        dates === null || dates === void 0 || dates.splice(selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$date2 = selectedFilters.date) === null || _selectedFilters$date2 === void 0 ? void 0 : _selectedFilters$date2.indexOf(it), 1);
        onSelectFilter('date', dates);
      }
    }), /*#__PURE__*/React.createElement("span", null, "".concat(new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      timeZone: 'UTC'
    }).format(new Date(it)), ",").concat(new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: '2-digit',
      timeZone: 'UTC'
    }).format(new Date(it)), ", ").concat((_Date = new Date(it)) === null || _Date === void 0 ? void 0 : _Date.getFullYear())));
  }), (selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$type = selectedFilters.types) === null || _selectedFilters$type === void 0 ? void 0 : _selectedFilters$type.length) > 0 && selectedFilters.types.map(function (it) {
    var _eventTypes$find;
    return /*#__PURE__*/React.createElement("div", {
      className: "filtered-item",
      style: commonstlye,
      key: it
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      sx: {
        fontSize: 12,
        borderRadius: '50%',
        backgroundColor: '#DDD',
        color: '#000'
      },
      onClick: function onClick() {
        var _selectedFilters$type2;
        var types = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.types;
        types === null || types === void 0 || types.splice(selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$type2 = selectedFilters.types) === null || _selectedFilters$type2 === void 0 ? void 0 : _selectedFilters$type2.indexOf(it), 1);
        onSelectFilter('type', types);
      }
    }), /*#__PURE__*/React.createElement("span", null, (_eventTypes$find = eventTypes.find(function (_it) {
      return _it.slug == it;
    })) === null || _eventTypes$find === void 0 ? void 0 : _eventTypes$find.name));
  }));
};
export default FilteredItem;